export const DISNEY_LAYOUT_0000 = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 336.5754,
      width: 3200,
      height: 4000,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.1688,
      scaleY: 0.1688,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/disney/02/background.png',
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'hulu',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 447.1294,
      top: 89.4514,
      width: 10417,
      height: 3392,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0101,
      scaleY: 0.0101,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/disney/02/hulu.png',
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      assignedAnimation: 'fadeIn',
      pieceId: 'character',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 249.7423,
      top: 413.0107,
      width: 1318,
      height: 3304,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.1579,
      scaleY: 0.1579,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 0.9836,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/disney/02/character.png',
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      assignedAnimation: 'zoomIn',
      pieceId: 'logo',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 786.802,
      width: 3200,
      height: 348,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.1372,
      scaleY: 0.1372,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: 'demo/disney/02/logo.png',
      crossOrigin: null,
      filters: []
    },
    {
      fontSize: 50,
      fontWeight: 'normal',
      fontFamily: 'Arial',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '2025 • Drama, Acción y Aventura',
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      assignedAnimation: 'slideDown',
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 270,
      top: 935.6579,
      width: 736.4014,
      height: 56.5,
      fill: '#ffffff',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.482,
      scaleY: 0.482,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    }
  ],
  background: '#000000'
};
